export default "__VITE_ASSET__6iFbPckF__"